// @flow
import styled from 'styled-components';
import { THead } from '../../components/TableX';

import colors from '../../assets/css/colors';

export const TableHead = styled(THead)`
	&.coach-stats{
		background: ${colors.coachPurple};
	}
`;

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Draft/THead.js